import React from 'react';
import { Col, Row } from 'antd';
import DetailedDeliveryCard from '../DetailedDeliveryCard/DetailedDeliveryCard';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TitleIcon from '../../assets/img/titleIcon.svg?react';
import Title from '../Page/Title';
import styles from './ActiveDeliveriesCards.module.less';

const CardsComponent = props => {
  const {
    deliveries,
    trackingData,
    onCancelDelivery,
    onRecreateDelivery,
    selectedDeliveryId,
    selectedCardRef,
    handleExpandClick,
    onCancelDeliveryAttempt,
    onCancelDeliveryAbort
  } = props;
  const { t } = useTranslation();
  return (
    <>
      <Title text={t('activeDeliveriesPage.title')} Icon={TitleIcon} />
      <Row gutter={[0, 16]} className={styles.cardsContainer}>
        {deliveries?.map(delivery => (
          <Col span={24} key={`${delivery.id}`}>
            <DetailedDeliveryCard
              trackingData={trackingData[delivery.id]}
              {...delivery}
              onRecreate={onRecreateDelivery}
              onCancel={onCancelDelivery}
              onCancelAttempt={onCancelDeliveryAttempt}
              onCancelAbort={onCancelDeliveryAbort}
              handleExpandClick={handleExpandClick}
              forwardedRef={selectedDeliveryId === delivery.id ? selectedCardRef : undefined}
              isExpanded={selectedDeliveryId === delivery.id}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

CardsComponent.propTypes = {
  deliveries: PropTypes.arrayOf(PropTypes.any),
  trackingData: PropTypes.object,
  onCancelDelivery: PropTypes.func,
  onRecreateDelivery: PropTypes.func,
  handleExpandClick: PropTypes.func,
  selectedDeliveryId: PropTypes.number,
  selectedCardRef: PropTypes.any,
  onCancelDeliveryAttempt: PropTypes.func,
  onCancelDeliveryAbort: PropTypes.func
};

export default CardsComponent;
